'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import AbstractTextElement from 'UIComponents/elements/AbstractTextElement';
import { escapeRegExp } from '../../utils/escapeRegExp';

const InputHighlighter = ({
  text,
  value
}) => {
  if (!value) {
    return text;
  }

  const parts = text ? text.split(new RegExp(`(${escapeRegExp(text)})`, 'gi')) : [];
  return /*#__PURE__*/_jsx(Fragment, {
    children: parts.map((part, index) => /*#__PURE__*/_jsx(AbstractTextElement, {
      weight: part.toLowerCase() === value.toLowerCase() ? 'bold' : 'regular',
      children: part
    }, index))
  });
};

InputHighlighter.propTypes = {
  text: PropTypes.string.isRequired,
  value: PropTypes.string
};
export default InputHighlighter;